import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, TextBody, TextTitle } from '../../atoms';
import { Table } from '../../organisms';
export default function ComponentWeb({ title, subtitle, header, noHeader, error, errorFallback, data, columns, backgroundInverted, children, onRowPressed, hideOnNoData, flatBorders = false, }) {
    return (_jsxs(Col, { children: [typeof title === 'string' ? _jsx(TextTitle, { small: true, children: title }) : title, !!subtitle && (_jsx(TextBody, { mt: "1", small: true, children: subtitle })), _jsx(View, { style: $.tableContainer, children: error ? (errorFallback) : (_jsx(Table, { header: header, data: data, columns: columns, backgroundInverted: backgroundInverted, onRowPressed: onRowPressed, noHeader: noHeader, hideOnNoData: hideOnNoData, flatBorders: flatBorders })) }), children] }));
}
const $ = StyleSheet.create({
    container: {},
    perfOptions: {
        height: 16,
        columnGap: theme.spacing['1'],
    },
    perfButton: {
        paddingLeft: 0,
        border: 'none',
    },
    tableContainer: {
        flex: 1,
        marginTop: theme.spacing[6],
        marginBottom: theme.spacing[4],
    },
});
